@if (anchor) {
  <a [id]="anchor"></a>
}

<div kb-layout="grid" class="row-container">
  <figure kb-overlay-figure
    kb-grid-item-columns="8"
    [heading]="attributes.topic"
    [abstract]="attributes.medium.attributes.caption"
    [link]="attributes.medium.attributes.link ? toPlainLink(attributes.medium.attributes.link) : undefined"
    [appEditorId]="editorIds?.topic"
  >
    <kb-picture
      [picture]="imageToPicture(attributes.medium.attributes, aspectRatio).sources"
      [appOgImage]="attributes.medium.attributes"
      [alt]="attributes.medium.attributes.alt"
      [rootColumns]="8"
      [appEditorId]="attributes.medium.editorIds?.src"
    ></kb-picture>
  </figure>
  <ul kb-grid-item-columns="4" class="link-list">
    @for (item of attributes.items; track item) {
      <li>
        <a [kbRouterOrExternalLink]="item.attributes.link.attributes.url" [attr.target]="item.attributes.link.attributes.target">
          @if (item.attributes.media.image) {
            <div class="icon">
              <img [src]="item.attributes.media.image.attributes.src" [alt]="item.attributes.media.image.attributes.alt" loading="lazy">
            </div>
          }
          <div>
            <h3 kb-heading class="link-heading">
              {{ item.attributes.link.attributes.label }}
              <kb-icon [icon]="iconLink"></kb-icon>
            </h3>
            <p kb-paragraph>
              <kb-line-clamp lines="2">
                {{ item.attributes.teaserText }}
              </kb-line-clamp>
            </p>
          </div>
        </a>
      </li>
    }
  </ul>
</div>
@if (createSectionButton) {
  <app-fs-button [value]="createSectionButton"></app-fs-button>
}
